import React, { useState, useEffect } from "react";
import {
  collection,
  onSnapshot,
  query,
  orderBy,
  addDoc,
  doc,
  deleteDoc,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { db } from "../firebase";

const Comments = ({ postId, postAuthor }) => {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    setCurrentUser(auth.currentUser);

    const commentsRef = collection(db, "posts", postId, "comments");
    const q = query(commentsRef, orderBy("createdAt", "desc"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const fetchedComments = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setComments(fetchedComments);
    });

    return () => unsubscribe();
  }, [postId]);

  const handleCommentSubmit = async (e) => {
    e.preventDefault();
    if (newComment.trim()) {
      const commentsRef = collection(db, "posts", postId, "comments");
      await addDoc(commentsRef, {
        text: newComment,
        createdAt: new Date(),
        author: currentUser.displayName,
        authorId: currentUser.uid,
      });
      setNewComment("");
    }
  };

  const handleDeleteComment = async (commentId, commentAuthorId) => {
    if (currentUser.uid === postAuthor || commentAuthorId === currentUser.uid) {
      const commentRef = doc(db, "posts", postId, "comments", commentId);
      await deleteDoc(commentRef);
    }
  };

  return (
    <div className="comments space-y-4">
      {comments.map((comment) => (
        <div
          key={comment.id}
          className="comment p-4 bg-gray-100 rounded-md shadow"
        >
          <p className="text-lg">{comment.text}</p>
          <p className="text-sm text-gray-500 mt-2">
            Written by: {comment.author} on{" "}
            {new Date(comment.createdAt.seconds * 1000).toLocaleDateString(
              "tr-TR",
              {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              }
            )}
          </p>
          {(currentUser.uid === postAuthor ||
            comment.authorId === currentUser.uid) && (
            <button
              onClick={() => handleDeleteComment(comment.id, comment.authorId)}
              className="mt-2 px-4 py-2 bg-red-500 text-white rounded hover:bg-red-700 transition duration-300"
            >
              Delete
            </button>
          )}
        </div>
      ))}

      <form onSubmit={handleCommentSubmit} className="space-y-4">
        <input
          type="text"
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          placeholder="Yorum yap..."
          className="w-full p-4 border rounded-md"
        />
        <button
          type="submit"
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-700 transition duration-300"
        >
          Gönder
        </button>
      </form>
    </div>
  );
};

export default Comments;
